<!-- stream-event-overlay.component.html -->
<div class="overlay" [class.visible]="showOverlay()">
    
    <!-- Видео-рамка -->
    @if (showOverlay()) {
        <div class="video-frame-container">
     
            <video #overlayVideo
                [src]="'assets/videos/10mincountdown.webm'"
                class="banner-media"
                autoplay
                muted
                (ended)="onVideoEnded()"
                >
            </video>
            
            <!-- Текст поверх видео -->
            @if (streamEvent()) {
                <div class="text-overlay">
                    <div class="coming-soon">Coming up next</div>
                    <div class="event-title">{{ streamEvent()!.title || '' }}</div>
                </div>
            }
        </div>
    }

</div>